import { vars } from '@repo/config';

interface IVaultConfig {
  vaultUrl: string;
  apiKey: string;
}

export function getVaultConfig(): IVaultConfig {
  return { vaultUrl: vars.url.vaultUrl, apiKey: vars.url.vaultApiKey };
}
